import { render, staticRenderFns } from "./SelectWorkflow.vue?vue&type=template&id=656fa6c4&scoped=true&"
import script from "./SelectWorkflow.vue?vue&type=script&lang=ts&"
export * from "./SelectWorkflow.vue?vue&type=script&lang=ts&"
import style0 from "./SelectWorkflow.vue?vue&type=style&index=0&id=656fa6c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656fa6c4",
  null
  
)

export default component.exports